import axios from '@/libs/axios'

export default {
  // Materials Write Off
  getMaterialsWriteOffExportExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      commit('application/SET_FILE_EXPORT_PROCESS_STATE', true, { root: true })
      axios({ url: 'materials-write-off-export/', method: 'GET', params, responseType: 'blob' })
        .then(res => resolve(res))
        .catch(e => {
          commit('application/SET_FILE_EXPORT_PROCESS_STATE', false, { root: true })
          reject({ message: e })
        })
    })
  },
  getMaterialsWriteOff({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'materials-write-off/', method: 'GET', params })
        .then(res => {
          commit('SET_MATERIALS_WRITE_OFF', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  // Cash Register
  getPatientPayments({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'patient-payment/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_PATIENTS_PAYMENTS', res.data.results)
          commit('SET_PATIENTS_PAYMENTS_COUNT', res.data.count)
          resolve(res)
        })
        .catch(e => reject({message: e}))
    })
  },
  getPatientPayment({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `patient-payment/${id}/`, method: 'GET' })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  addPatientPayment({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'patient-payment/',
        method: 'POST',
        data: data,
      })
        .then(res => {
          commit('ADD_PATIENT_PAYMENT', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  editPatientPayment({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({url: `patient-payment/${payload.id}/`, method: 'PATCH', data: payload})
        .then(res => {
          commit('EDIT_PATIENT_PAYMENT', res.data)
          resolve(res)
        })
        .catch(e => reject({message: e}))
    })
  },
  deletePatientPayment({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `patient-payment/${id}/`,
        method: 'DELETE'
      })
        .then(res => {
          commit('DELETE_PATIENT_PAYMENT', id)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getCashRegisterTotal({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'cash-register-total/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_CASH_REGISTER_TOTAL', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  addIntegratorDailyRevenue({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `integrator-daily-revenue/`,
        method: 'POST',
        data: payload
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  editIntegratorDailyRevenue({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `integrator-daily-revenue/${payload.id}/`,
        method: 'PATCH',
        data: payload
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getTotalByDirection({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'cash-register-total-by-direction/', method: 'GET', params })
        .then(res => {
          commit('SET_TOTAL_BY_DIRECTION', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  getTotalBySnapshot({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'cash-register-total-by-snapshot/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_TOTAL_BY_SNAPSHOT', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getTotalBySelling({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'cash-register-total-by-selling/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_TOTAL_BY_SELLING', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getTotalByDiscount({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'cash-register-total-by-discount/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_TOTAL_BY_DISCOUNT', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getTotalByPrepayment({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'cash-register-total-by-prepayment/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_TOTAL_BY_PREPAYMENT', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  // Debtors
  getDebtors({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'debtors/', method: 'GET', params })
        .then(res => {
          commit('SET_DEBTORS', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  // Advances
  getAdvances({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'advances/', method: 'GET', params })
        .then(res => {
          commit('SET_ADVANCES', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  // Insurance
  getInsurances({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'insurance/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  getInsurancesPerPage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({url: 'insurance/', method: 'GET', params: params})
        .then(res => {
          commit('SET_INSURANCES_PER_PAGE', res.data.results)
          commit('SET_INSURANCES_PER_PAGE_TOTAL_COUNT', res.data.count)
          resolve(res)
        })
        .catch(e => reject({message: e}))
    })
  },
  // Insurance company document
  getInsuranceCompanyDocument({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({
        url: `finance/insurance-company/${data.companyId}/document`, method: 'GET', params: data.params,
        responseType: 'blob'
      })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  getInsurancesExportExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'insurance-export/', method: 'GET', params: params, responseType: 'blob' })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  addInsurance({commit}, formData) {
    return new Promise((resolve, reject) => {
      axios({ url: 'insurance/', method: 'POST', data: formData, headers: {'Content-Type': 'multipart/form-data'} })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  editInsurance({commit}, formData) {
    return new Promise((resolve, reject) => {
      axios({
        url: `insurance/${formData.get('id')}/`, method: 'PATCH', data: formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  deleteInsurance({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `insurance/${id}/`, method: 'DELETE' })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  // Certificate
  getCertificates({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'certificate/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_CERTIFICATES', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  getCertificatesPerPage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({url: 'certificate/', method: 'GET', params: params})
        .then(res => {
          commit('SET_CERTIFICATES_PER_PAGE', res.data.results)
          commit('SET_CERTIFICATES_PER_PAGE_TOTAL_COUNT', res.data.count)
          resolve(res)
        })
        .catch(e => reject({message: e}))
    })
  },
  getCertificatesExportExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `certificate-export/`, method: 'GET',
        params: params,
        responseType: 'blob',
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  addCertificate({commit}, formData) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'certificate/',
        method: 'POST',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(res => {
          commit('CERTIFICATE_ADDED', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  editCertificate({commit}, formData) {
    return new Promise((resolve, reject) => {
      axios({
        url: `certificate/${formData.get('id')}/`,
        method: 'PATCH',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(res => {
          commit('CERTIFICATE_EDITED', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  deleteCertificate({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `certificate/${id}/`,
        method: 'DELETE'
      })
        .then(res => {
          commit('DELETE_CERTIFICATE', id)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  // Cashless payments
  getCashlessPayments({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'cashless-payment/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_CASHLESS_PAYMENTS', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  addCashlessPayment({commit}, formData) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'cashless-payment/',
        method: 'POST',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(res => {
          commit('CASHLESS_PAYMENT_ADD', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  editCashlessPayment({commit}, formData) {
    return new Promise((resolve, reject) => {
      axios({
        url: `cashless-payment/${formData.get('id')}/`,
        method: 'PATCH',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(res => {
          commit('CASHLESS_PAYMENT_EDIT', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  deleteCashlessPayment({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `cashless-payment/${id}/`,
        method: 'DELETE'
      })
        .then(res => {
          commit('DELETE_CASHLESS_PAYMENT', id)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getCashlessPaymentsExportExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `cashless-payment-export/`, method: 'GET',
        params: params,
        responseType: 'blob',
      })
        .then(res => {
          resolve(res)
        }).catch(error => {
        reject({message: error})
      })
    })
  },
}
